import { Component, inject, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { CommonModule } from '@angular/common';
import { AuthStateService } from '@app/core/auth/auth-state.service';

@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: true,
    imports:  [ CommonModule, DashboardComponent]
})

export class HomeComponent implements OnInit {
    authService = inject(MsalService);
    router = inject(Router);  
    authStateService = inject(AuthStateService);

    async ngOnInit() {
        const accounts = this.authService.instance.getAllAccounts();
        if (accounts.length > 0) {
            await this.router.navigate(['/dashboard']);
            return;
        }
    }
}




   